<div class="subtitle" *ngIf="orgInfoReady">
  <button (click)="SetView('projects')" type="button" title="Organization Information"
  class="btn btn-primary">
   <span class="fas fa-map"></span>
 </button>
  <button (click)="SetView('metadata')" type="button" title="Organization Information"
   class="btn btn-primary">
    <span class="fas fa-sitemap"></span>
  </button>
  <button (click)="SetView('employees')" type="button" title="Employees"
    class="btn btn-primary">
    <span class="fas fa-address-book"></span>
  </button>
  <button (click)="SetView('crews')" type="button" title="Crews" class="btn btn-primary">
    <span class="fas fa-users"></span>
  </button>
  <button (click)="SetView('templates')" type="button" title="Templates" class="btn btn-primary">
    <span class="fas fa-archive"></span>
  </button>
</div>
<div class="workspace" *ngIf="orgInfoReady">
  <app-view-stack [viewName]="currentView">
    <app-view-stack-view viewName="projects">
      <app-projects></app-projects>
    </app-view-stack-view>
    <app-view-stack-view viewName="metadata">
      <app-org-metadata [orgId]="orgId"></app-org-metadata>
    </app-view-stack-view>
    <app-view-stack-view viewName="employees">
      <app-org-employees></app-org-employees>
    </app-view-stack-view>
    <app-view-stack-view viewName="templates">
      <app-org-templates></app-org-templates>
    </app-view-stack-view>
    <app-view-stack-view viewName="configurations">
      <app-org-configs></app-org-configs>
    </app-view-stack-view>

  </app-view-stack>
</div>
<div class="footer"></div>
